import React, { useEffect, useState } from "react";
import Helper from "../../helper";
import moment from "moment";
import axios from "axios";
import Appconfig from "../../config/config";

const AccountStatement = () => {
  const userInfo = Helper(); // get login user details

  const [data, setData] = useState([]);

  const [formData, setFormData] = useState({
    user_id: userInfo && userInfo?._id,
    type: "0",
    from_date: moment().subtract(7, "days").format("YYYY-MM-DD"), // ✅ 7 days ago
    to_date: moment().format("YYYY-MM-DD"), // ✅ today
    game_type: "All",
  });

  const getAccountStatement = async () => {
    try {
      const config = {
        method: "post",
        url: `${Appconfig.apiUrl}reports/aurafilteraccountStatement`,
        headers: {
          "Content-Type": "application/json",
        },
        data: JSON.stringify(formData),
      };

      const response = await axios(config);
      setData(response.data.resultData);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getAccountStatement();
  }, []);

  const handleToDate = (newDate) => {
    if (newDate) {
      setFormData({
        ...formData,
        to_date: newDate,
      });
    }
  };

  const handleFromDate = (newDate) => {
    if (newDate) {
      setFormData({
        ...formData,
        from_date: newDate,
      });
    }
  };

  // ✅ TRs with borders
  const renderRows = () => {
    if (data && data.length > 0) {
      return data.map((record, index) => (
        <tr
          key={index}
          className="text-sm font-medium bg-white hover:bg-[#f1faf7] transition"
        >
          <td className="px-4 py-3 text-center border border-gray-200">
            {new Date(record.createdAt).toLocaleString()}
          </td>
          <td className="px-4 py-3 text-center border border-gray-200">
            {record.remarks}
          </td>
          <td className="px-4 py-3 text-center border border-gray-200">
            {record.transaction_type === "Credit" ? (
              <span className="text-[#508d0e] font-bold">{record.amount}</span>
            ) : (
              "-"
            )}
          </td>
          <td className="px-4 py-3 text-center border border-gray-200">
            {record.transaction_type === "Debit" ? (
              <span className="text-[#d50000] font-bold">{record.amount}</span>
            ) : (
              "-"
            )}
          </td>
          <td className="px-4 py-3 text-center border border-gray-200 flex items-center justify-center gap-1">
            {record.from}
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="black"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M9 17V7L16 12L9 17Z" />
            </svg>
            {record.to}
          </td>
          <td className="px-4 py-3 text-center border border-gray-200 font-bold text-[#0c9971]">
            {record.balance}
          </td>
        </tr>
      ));
    } else {
      return (
        <tr>
          <td
            colSpan="6"
            className="px-4 py-6 text-center text-gray-500 italic bg-white border border-gray-200"
          >
            No records found
          </td>
        </tr>
      );
    }
  };

  return (
    <>
      {/* Header */}
      <div className="account-statment p-6">
        <h2 className="text-2xl font-bold text-[#0c9971] mb-2">
          Account Statement
        </h2>

        {/* Date filter form */}
        <div className="bg-white rounded-xl shadow-sm p-4 mb-2">
          <form className="flex flex-col md:flex-row items-center gap-4">
            {/* From Date */}
            <input
              type="date"
              name="from_date"
              onChange={(e) => handleFromDate(e.target.value)}
              value={formData?.from_date || new Date()}
              className="border border-gray-300 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-[#0c9971] outline-none"
            />
            {/* To Date */}
            <input
              type="date"
              name="to_date"
              onChange={(e) => handleToDate(e.target.value)}
              value={formData?.to_date || new Date()}
              className="border border-gray-300 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-[#0c9971] outline-none"
            />
            {/* Buttons */}
            <div className="flex gap-3">
              <button
                type="button"
                onClick={() => getAccountStatement()}
                className="bg-gradient-to-r from-[#0c9971] to-[#0a7d5c] text-white px-6 py-2 rounded-lg shadow-md hover:shadow-lg transition font-semibold"
              >
                Submit
              </button>
              <button
                type="reset"
                className="bg-gray-200 text-gray-700 px-6 py-2 rounded-lg hover:bg-gray-300 transition font-semibold"
              >
                Reset
              </button>
            </div>
          </form>
        </div>
      </div>

      {/* Tailwind Table */}
      <div className="table-container mx-2 bg-white rounded-2xl shadow-md p-4">
        <div className="overflow-x-auto">
          <table className="w-full border border-gray-200 border-collapse rounded-lg overflow-hidden">
            <thead>
              <tr className="bg-gradient-to-r from-[#0c9971] to-[#0a7d5c] text-white text-sm">
                <th className="px-4 py-3 text-center border border-gray-200">
                  Date
                </th>
                <th className="px-4 py-3 text-center border border-gray-200">
                  Remark
                </th>
                <th className="px-4 py-3 text-center border border-gray-200">
                  Deposit
                </th>
                <th className="px-4 py-3 text-center border border-gray-200">
                  Withdraw
                </th>
                <th className="px-4 py-3 text-center border border-gray-200">
                  From / To
                </th>
                <th className="px-4 py-3 text-center border border-gray-200">
                  Balance
                </th>
              </tr>
            </thead>
            <tbody>{renderRows()}</tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default AccountStatement;
